import {
  base_colorContentBorder,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

/**
 * The fullscreen BaseModal variant zeroes its body padding, so the wizard owns
 * the modal frame. Every band (header, stepper, content, footer) shares the
 * same spacing(10) horizontal inset, and the top of the header / bottom of the
 * footer carry the full spacing(10) so the whole modal reads as a single
 * spacing(10) frame — no double-padding from a wrapper.
 */
const frameInline = spacing(10)

export const root = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`

export const header = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  padding: ${spacing(10)} ${frameInline} ${spacing(4)};
  border-bottom: 1px solid ${base_colorContentBorder};
`

export const headerSubtitle = css`
  font-family: ${font_family_weight_regular};
  ${font_md}
  color: ${text_colorTextSecondary};
  margin: 0;
`

export const body = css`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 640px) {
    flex-direction: column;
    overflow: auto;
  }
`

export const main = css`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

export const content = css`
  flex: 1;
  overflow-y: auto;
  padding: ${spacing(6)} ${frameInline};
`

export const footer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${frameInline} ${spacing(10)};
  border-top: 1px solid ${base_colorContentBorder};
`
